import React from 'react';
import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import SetPasswordPage from 'components/AuthNew/SetPasswordPage';

const SetPasswordPagePage = props => {
  return (
    <div>
      <HeaderFooterLayout>
        <SetPasswordPage {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default SetPasswordPagePage;
